<template>
  <div>
    <div class="row m-0 table-row">
      <div class="col-4 py-2 px-3">
        <div
          class="d-flex align-items-center parent-title"
        >
          <p class="m-0">{{ parsedPermission.name }}</p>
        </div>
      </div>
      <div class="col-2 py-2 px-3 d-flex align-items-center">
        <checkbox
          :active="permissionValue.includes(parsedPermission.access['read'])"
          :disabled="!parsedPermission.access['read']"
          @change="onChange($event, parsedPermission.access['read'])"
        />
      </div>
      <div class="col-2 py-2 px-3 d-flex align-items-center">
        <checkbox
          :active="permissionValue.includes(parsedPermission.access['create'])"
          :disabled="!parsedPermission.access['create']"
          @change="onChange($event, parsedPermission.access['create'])"
        />
      </div>
      <div class="col-2 py-2 px-3 d-flex align-items-center">
        <checkbox
          :active="permissionValue.includes(parsedPermission.access['update'])"
          :disabled="!parsedPermission.access['update']"
          @change="onChange($event, parsedPermission.access['update'])"
        />
      </div>
      <div class="col-2 py-2 px-3 d-flex align-items-center">
        <checkbox
          :active="permissionValue.includes(parsedPermission.access['delete'])"
          :disabled="!parsedPermission.access['delete']"
          @change="onChange($event, parsedPermission.access['delete'])"
        />
      </div>
    </div>
    <hr class="m-0" />
  </div>
</template>

<script>
import { Checkbox } from "@/components/Input";

export default {
  name: "NonInternalCheckboxWrapper",
  components: { Checkbox },
  props: {
    permission: {
      type: Object,
      required: true,
    },
    permissionValue: {
      type: Array,
      required: true,
    },
  },
  computed: {
    parsedPermission() {
        const access = {};
        this.permission.children.forEach((element) => {
            access[element.type] = element.permission
        })
      return {
        name: this.permission.name,
        access,
      };
    },
  },
  methods: {
    onChange(value, type) {
        let result = this.permissionValue
        if (value.active) {
            result.push(type)
        } else {
            result = result.filter((item) => item !== type)
        }
        this.$emit('change', result)
    }
  },
};
</script>

<style scoped>
label {
  margin-bottom: 0;
}

.table-row p {
  font-size: 14px;
  color: #374151;
}

.arrow {
  font-size: 12px;
  margin-right: 18px;
  transform: rotate(0deg);
  margin-bottom: 0;
  height: 14px;
  width: 14px;
}

.arrow-bottom {
  transform: rotate(90deg);
}

.child-title {
  margin-left: 50px;
}

.parent-title {
  font-weight: 600;
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/Employee/Components/RolesAndPermissions/CheckboxWrapper/NonInternal.vue